module.exports = __webpack_public_path__ + "static/media/Elise2.e75a66dd.jpg";